import { ArrowLeft2 } from 'iconsax-react';
import Link from 'next/link';
import { ReactNode, useEffect } from 'react';

import { Label } from '@/components/ui/label/label';
import { SkeletonText } from '@/components/shared/SkeletonText';
import { useProfileSecurity } from '@entities/user';
import { Card } from '@shared/ui';

import { language, TabRoutesEnum, useProfileSecurityTabsConfig } from '../../model';

export const ProfileSecurityMobileLayout = ({ children }: { children: ReactNode }) => {
  const { data, isPending } = useProfileSecurity();
  const { tabsConfig, isInRoot } = useProfileSecurityTabsConfig(true);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }, []);

  return (
    <>
      {isInRoot && (
        <div className='px-2 pt-5 mt-[calc(5px_+_var(--mobileHeaderHeight))]'>
          <Card className='py-3 px-4'>
            <div className='flex w-full flex-col items-center justify-center'>
              <div className='w-full divide-y divide-border'>
                {tabsConfig.map((tab) => (
                  <Link
                    key={tab.id}
                    href={tab.href}
                    className='flex w-full items-center justify-between active:bg-hover'
                  >
                    <div className='pointer-events-none flex w-full items-center justify-start gap-[12px] py-[16px]'>
                      {tab.mobileIcon}
                      <Label className='body-14-regular leading-[24.18px]'>{tab.label}</Label>
                    </div>
                    {tab.key === TabRoutesEnum.twoFA && (
                      <p className='pointer-events-none text-sm text-gray ml-3'>
                        {isPending ? (
                          <SkeletonText className='h-[10px] w-[50px]' />
                        ) : data?.twoFactorAuthentication === false ? (
                          language.inactive
                        ) : (
                          data?.twoFactorAuthentication === true && language.active
                        )}
                      </p>
                    )}
                    <ArrowLeft2 size={18} />
                  </Link>
                ))}
              </div>
            </div>
          </Card>
        </div>
      )}
      <div className={isInRoot ? 'hidden' : ''}>{children}</div>
    </>
  );
};
